module.exports = __webpack_public_path__ + "img/img4.250c09b0.jpg";